// extracted by mini-css-extract-plugin
export default {"inputDouble":"styles_inputDouble__Fqsz0"};